<style scoped>
    /*主体内容*/
    .layout-main{
        overflow: auto;
    }
    /*左侧栏*/
    .layout-main .leftSider{
        /*background-color: #ffffff;*/
    }
    /*左侧滚动条菜单*/
    .layout-main .leftmenu{
        /*height: calc(100% - 150px);*/
        height:100%;
        overflow: auto;
    }
    /* 右侧内容 */
    .layout-main .rightContent{
        /*padding:8px 15px ;*/
        height: 100%;
        position: relative;
        padding: 24px;
        display: flex;
        flex-direction: column;
    }
    .layout-main .c-content{
        flex: 1;
        position: relative;
        overflow: hidden;
        overflow-y: auto;
    }
    /* 面包屑 */
    .c-bread-wrapper{
        padding: 10px 20px;
        z-index: 10;
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 1px 0px 0px #E3E8EE;
    }
    .c-bread{

    }
    .c-bread-item{

    }
</style>
<style>
    /*左侧菜单栏*/
    .h-layout-main .ivu-menu,
    .h-layout-main .ivu-menu-item {

    }
    .h-layout-main .ivu-menu-vertical .ivu-menu-item:hover,
    .h-layout-main .ivu-menu-vertical .ivu-menu-submenu-title:hover{

    }
    .c-bread .ivu-breadcrumb-item-separator{
        color: #333333;
    }
</style>
<template>
    <Layout class="layout-main">
        <Sider ref="leftSider"
               width="200"
               hide-trigger
               class="leftSider"
        >
            <Menu ref="leftmenu"
                  width="auto"
                  class="leftmenu"
                  :active-name="actMenuName"
                  :open-names="openMenus"
                  accordion
                  @on-select="handleOnSelect">
                <div v-for="item in menuLists" :key="item.id">
                    <Submenu v-if="item.children && item.children.length>1" :name="item.url">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span class="menu-span">{{item.name}}</span>
                        </template>
                        <MenuItem v-for="cmenu in item.children" :name="cmenu.url" :key="cmenu.id">
                            <!-- <i :class="item.icon"></i> -->
                            <span class="menu-span">{{cmenu.name}}</span>
                        </MenuItem>
                    </Submenu>
                    <template v-else>
                        <MenuItem v-if="item.children && item.children.length === 1" :name="item.children[0].url">
                            <i :class="item.icon"></i>
                            <span class="menu-span">{{item.children[0].name}}</span>
                        </MenuItem>
                        <MenuItem v-else :name="item.url">
                            <i :class="item.icon"></i>
                            <span class="menu-span">{{item.name}}</span>
                        </MenuItem>
                    </template>
                </div>
            </Menu>
        </Sider>
        <Content id="rightContent" class="rightContent">
            <div v-if="$route.meta.pname" class="ajFlex c-bread-wrapper" style="justify-content: flex-start;">
                <div style="padding: 0 12px 0 0; margin-right: 12px; border-right: 1px solid lightgray; cursor: pointer;" @click='handleBack'><Icon type="md-arrow-round-back" style="font-size: 18px;margin-right: 6px;"/>返回</div>
                <Breadcrumb class="c-bread aFlex">
                    <BreadcrumbItem class="c-bread-item">
                        <span>{{$route.meta.title}}</span>
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="c-content">
                <keep-alive>
                    <!--会被缓存的视图组件-->
                    <router-view v-if="$route.meta.keepAlive" ref="keepList"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
        </Content>
    </Layout>
</template>
<script>
    import {mapState,mapMutations,mapActions} from 'vuex';
    import {routers} from '@/router';
    export default {
        data () {
            return {
                // 菜单列表
                // menuLists:[],
                // 展开的菜单
                openMenus:[],
                // 激活菜单
                actMenuName:'',
            };
        },
        computed: {
            ...mapState(['navList','area','citys','areaCode', 'isReset']),
            showSelect(){
                let noYZT=(this.$route.matched.slice(-1)[0].name !== 'statistics');
                let isName=(this.$route.matched[0].name==='supervision');
                let isShow=!this.$route.matched[this.$route.matched.length-1].meta.pname;
                return isName && isShow && noYZT;
            },
            // curCityCode(){
            //     return [this.areaCode]
            // },
            // 激活的导航name
            actNavName(){
                return this.$route.matched[0].name;
            },
            // 菜单列表
            menuLists(){
                let filterNav = this.navList.filter((item)=> {
                    return item.url === this.actNavName;
                });
                let list=[];
                if(filterNav.length>0 && filterNav[0].children){
                    list = filterNav[0].children;
                }
                list.map((it) => {
                    switch(it.name) {
                        case '统计分析':
                            it.icon = 'iconfont iconzhutu-fill'
                            break;
                        case '综合监管':
                            it.icon = 'iconfont iconkanban-fill'
                            break;
                        case '综合查询':
                            it.icon = 'iconfont iconchakan-fill'
                            break;
                        case '数据分析':
                            it.icon = 'iconfont iconshuju-fill'
                            break;
                        case '系统管理':
                            it.icon = 'iconfont iconxitongshezhi-fill'
                            break;
                        case '预警管理':
                            it.icon = 'iconfont iconyujing-fill'
                            break;
                        default:
                            break
                    }
                })
                return list;
            },
            //所有的菜单项目
            menus(){
                let mArr=[];
                this.menuLists.forEach((item)=>{
                    if (item.children && item.children.length>0){
                        item.children.forEach((c)=>{
                            mArr.push(c);
                        });
                    }else {
                        mArr.push(item);
                    }
                });
                return mArr;
            },
            // 面包屑数组
            breadcrumbs(){
                let breadcrumbs=[];
                breadcrumbs=this.$route.matched.slice(1);
                return breadcrumbs;
            }
        },
        watch:{
            '$route': function (to, from) {
                // console.log(this.$route);
                // console.log(to)
                // console.log(from)
                if(from.meta.keepAlive && from.meta.pname !== to.name) {
                    this.SetReset(true);
                }else {
                    this.SetReset(false);
                }
            },
            menuLists:function () {
                this.getActMenu();
            }
        },
        created(){
            // 获取激活的菜单值
            this.getActMenu();
            // 获取展开的菜单
            this.getOpenMenus();
        },
        mounted(){

        },
        methods: {
            ...mapMutations(['SetAreaCode', 'SetReset']),
            // areaChange(value,selectedData){
            //     if(selectedData.length){
            //         var item=selectedData[selectedData.length-1];
            //         this.SetAreaCode(item.value);
            //     }else {
            //         this.SetAreaCode('');
            //     }
            //
            // },
            handleBack(){
              this.$router.go(-1);
            },
            // 获取当前菜单值
            getActMenu(){
                this.actMenuName=this.$route.meta.pname || this.$route.name;
                this.setMenu();
            },
            // 更新菜单
            setMenu(){
                this.$nextTick(()=>{
                    this.$refs.leftmenu.updateActiveName();
                    this.$refs.leftmenu.updateOpened();
                });
            },
            //菜单选择事件
            handleOnSelect(name){
                if(!name){
                    this.$Message.warning('暂无该模块!');
                    return;
                }
                let filterMenu = this.menus.filter((item)=> {
                    return item.url === name;
                });
                if(filterMenu && filterMenu.length>0){
                    // iframe页面
                    if(filterMenu[0].iframe){
                        // 保存当前的导航菜单name
                        this.$router.push({
                            name: name,
                            params:{
                                path:name
                            }
                        });
                    }else {
                        this.$router.push({
                            name: name,
                        });
                    }
                }else {
                    this.$Message.error('暂无该页面!')
                }
            },
            // 获取展开的菜单
            getOpenMenus(){
                let ops=[];
                if(this.$route.matched[1]){
                    ops=[this.$route.matched[1].name];
                }
                this.openMenus=ops;
            },
        }
    };
</script>
